import React, { useEffect, useState } from "react";
import { LinkOutlined, CopyOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { getShareShipment } from "@/services/shipments_new";

const copyMapUrl = url => {
  window.open(url, "_blank");
};

const copyUrl = url => {
  navigator.clipboard.writeText(url);
  message.success("Copied link!");
};

const CopyButton = ({ shipmentId }) => {
  const [shareUrl, setShareUrl] = useState("");

  useEffect(() => {
    getShareShipment(shipmentId).then(data => {
      setShareUrl(data);
    });
  }, []);

  return (
    <div style={{ marginTop: 22 }}>
      <Button icon={<LinkOutlined />} onClick={() => copyMapUrl(shareUrl)}>
        View
      </Button>
      <Button icon={<CopyOutlined />} onClick={() => copyUrl(shareUrl)} style={{ marginLeft: 16 }}>
        Copy
      </Button>
    </div>
  );
};

export default CopyButton;
